import { render } from "./MetricLintDetailPage.vue?vue&type=template&id=8d4b9c0e&scoped=true"
import script from "./MetricLintDetailPage.vue?vue&type=script&lang=js"
export * from "./MetricLintDetailPage.vue?vue&type=script&lang=js"

import "./MetricLintDetailPage.vue?vue&type=style&index=0&id=8d4b9c0e&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d4b9c0e"]])

export default __exports__